import { MoonStar, Sun } from 'lucide-react';
import { useTheme } from '@/layouts/theme-mode-context';
import { useSidebar } from '@/components/ui/sidebar';
import { motion, AnimatePresence } from 'framer-motion';

export function ThemeModeSwitcher() {
  const { theme, toggleTheme } = useTheme();
  const { open, openMobile } = useSidebar();

  const iconAnimation = {
    initial: { opacity: 0, rotate: -10, scale: 0.8 },
    animate: {
      opacity: 1,
      rotate: 0,
      scale: 1,
      transition: {
        duration: 0.2,
        ease: 'easeOut'
      }
    },
    exit: {
      opacity: 0,
      rotate: 10,
      scale: 0.8,
      transition: {
        duration: 0.2,
        ease: 'easeIn'
      }
    },
    whileHover: {
      scale: 1.1,
      rotate: 5,
      transition: {
        type: 'spring',
        stiffness: 400,
        damping: 25
      }
    }
  };

  return (
    <div className={`${open || openMobile ? 'pl-4' : 'pl-2'} pb-4`}>
      <AnimatePresence mode="wait" initial={false}>
        {theme === 'dark' ? (
          <motion.div
            key="dark"
            {...iconAnimation}
            className="cursor-pointer hover:text-primary w-4 h-4 flex items-center justify-center"
            onClick={toggleTheme}
          >
            <MoonStar size={16} />
          </motion.div>
        ) : (
          <motion.div
            key="light"
            {...iconAnimation}
            className="cursor-pointer hover:text-primary w-4 h-4 flex items-center justify-center"
            onClick={toggleTheme}
          >
            <Sun size={16} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
